import { useEffect } from "react";
import {
  Tooth, Stethoscope, Sparkle, PersonSimpleRun, Brain, Carrot, PawPrint, HandHeart, Briefcase, Calculator,
} from "@phosphor-icons/react";
import { useAuth } from "./auth";

export const PROFESSIONS = [
  { key: "dentista", label: "Dentista", icon: Tooth, color: "#4F46E5", client: "paciente", place: "clínica", de: "da", procedures: "Procedimentos", tagline: "Precificação para consultórios odontológicos" },
  { key: "medico", label: "Médico(a)", icon: Stethoscope, color: "#0E7490", client: "paciente", place: "clínica", de: "da", procedures: "Procedimentos", tagline: "Precificação para consultórios médicos" },
  { key: "esteticista", label: "Esteticista", icon: Sparkle, color: "#DB2777", client: "cliente", place: "clínica de estética", de: "da", procedures: "Procedimentos", tagline: "Precificação para estética e beleza" },
  { key: "fisioterapeuta", label: "Fisioterapeuta", icon: PersonSimpleRun, color: "#059669", client: "paciente", place: "clínica", de: "da", procedures: "Sessões / Procedimentos", tagline: "Precificação para fisioterapia" },
  { key: "psicologo", label: "Psicólogo(a)", icon: Brain, color: "#7C3AED", client: "paciente", place: "consultório", de: "do", procedures: "Sessões", tagline: "Precificação para psicologia" },
  { key: "nutricionista", label: "Nutricionista", icon: Carrot, color: "#EA580C", client: "paciente", place: "consultório", de: "do", procedures: "Consultas / Planos", tagline: "Precificação para nutrição" },
  { key: "veterinario", label: "Veterinário(a)", icon: PawPrint, color: "#B45309", client: "tutor", place: "clínica veterinária", de: "da", procedures: "Procedimentos", tagline: "Precificação para veterinária" },
  { key: "massoterapeuta", label: "Massoterapeuta", icon: HandHeart, color: "#0D9488", client: "cliente", place: "espaço", de: "do", procedures: "Sessões", tagline: "Precificação para massoterapia" },
  { key: "outro", label: "Outra área da saúde", icon: Briefcase, color: "#C5A059", client: "cliente", place: "clínica", de: "da", procedures: "Procedimentos", tagline: "Precificação para profissionais de saúde" },
];

const DEFAULT = { key: "default", label: "Profissional", icon: Calculator, color: "#4F46E5", client: "paciente", place: "clínica", de: "da", procedures: "Procedimentos", tagline: "Precificação inteligente" };

export const getProfession = (key) => PROFESSIONS.find((p) => p.key === key) || PROFESSIONS[0];
export const cap = (s) => s.charAt(0).toUpperCase() + s.slice(1);
export const singularProc = (p) => (p.procedures.startsWith("Sess") ? "Sessão" : p.procedures.startsWith("Serv") ? "Serviço" : p.procedures.startsWith("Consult") ? "Consulta" : "Procedimento");

function hexToRgb(hex) {
  const n = parseInt(hex.slice(1), 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}


export function applyProfessionTheme(prof) {
  const [r, g, b] = hexToRgb(prof.color);
  const root = document.documentElement;
  root.style.setProperty("--brand", prof.color);
  root.style.setProperty("--brand-rgb", `${r}, ${g}, ${b}`);
  document.title = prof.key === "default" ? "O Seu Precificador" : `O Seu Precificador · ${prof.label}`;
}

export function useProfession() {
  const { user } = useAuth();
  const prof = user ? getProfession(user.profession) : DEFAULT;
  useEffect(() => { applyProfessionTheme(prof); }, [prof]);
  return prof;
}
